module.exports = __webpack_public_path__ + "static/media/girl_painting.83c89ea5.png";